<app-shared-dialog [options]="{
  confirmText: (data.status === 'Approved' && (data.source === 'agents' && data.agentId !== null && data.agentId !== 0) ? 'Catalogs.new_catalog.confirmation.go_to_agent_detail' : 'Catalogs.new_catalog.confirmation.go_to_catalog_list') | translate,
  cancelText: 'common.cancel' | translate,
  hideHeader: true
}" (confirm)="goBack()"
  (cancel)="cancel()">
  <div class="confirmation-dialog">
    <img src="assets/images/bloc-note.svg" alt="" />
    <span class="title">
      {{ (data.status === 'Draft' ? 'Catalogs.new_catalog.confirmation.saved_as_draft' : 'Catalogs.new_catalog.confirmation.published') | translate }}
    </span>
    <p class="sub" *ngIf="data.status === 'Draft'">
      <ng-container *ngIf="data.hasSourceAgent; else draftNoAgent">
        {{ 'Catalogs.new_catalog.confirmation.saved_as_draft_assigned' | translate }}
      </ng-container>
      <ng-template #draftNoAgent>
        {{ 'Catalogs.new_catalog.confirmation.saved_as_draft_no_agent' | translate }}
      </ng-template>
    </p>
    <p class="sub" *ngIf="data.status === 'Approved'">
      <ng-container *ngIf="data.hasSourceAgent; else approvedNoAgent">
        {{ 'Catalogs.new_catalog.confirmation.published_assigned' | translate }}
      </ng-container>
      <ng-template #approvedNoAgent>
        {{ 'Catalogs.new_catalog.confirmation.published_no_agent' | translate }}
      </ng-template>
    </p>
  </div>
</app-shared-dialog>
